import { Flex } from "antd";
import { MainPageTitle } from "@/entities/main-page-title";
import { PasswordRecoverySteps, usePasswordRecoveryContent } from "../model";
import { PhoneNumberStep, SmsCodeStep, SuccessStep, NewPasswordStep } from "./components";

export const PasswordRecoveryContent = () => {
  const { step, title, subtitle, hideTitle } = usePasswordRecoveryContent();

  const renderStepContent = () => {
    switch (step) {
      case PasswordRecoverySteps.PHONE_NUMBER_STEP:
        return <PhoneNumberStep />;
      case PasswordRecoverySteps.SMS_CODE_STEP:
        return <SmsCodeStep />;
      case PasswordRecoverySteps.NEW_PASSWORD_STEP:
        return <NewPasswordStep />;
      case PasswordRecoverySteps.SUCCESS_STEP:
        return <SuccessStep />;
      default:
        return null;
    }
  };

  return (
    <Flex vertical gap={32} style={{ height: "100%" }}>
      {!hideTitle && <MainPageTitle title={title} subtitle={subtitle} />}
      {renderStepContent()}
    </Flex>
  );
};
